var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-3 text-center"},[_c('span',{staticClass:"text-light"},[_vm._v(_vm._s(new Date().getFullYear())+" - All Rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }